<template>
  <v-card width="50%" class="mx-auto">
    <v-label for="fname">Name*</v-label>
    <v-text-field
      id="fname"
      class="full"
      v-model="$v.formResponses.name.$model"
      type="text"
    />
    <p class="error" v-if="!$v.formResponses.name.required">
      this field is required
    </p>
    <p class="error" v-if="!$v.formResponses.name.minLength">
      Field must have at least
      {{ $v.formResponses.name.$params.minLength.min }} characters.
    </p>
  </v-card>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      formResponses: {
        name: "",
      },
    };
  },
  validations: {
    formResponses: {
      name: {
        required,
        minLength: minLength(2),
      },
    },
  },
};
</script>

